import grpc from '@/api/request'
import { kpNotice } from '@/util/notice'

function getAllAddress(params) {
  grpc.call('/basic/all', params)
    .then(response => {
      // console.log('获取全部省市区数据', response)
      if (response.code === 0) {
        params.callback(response)
      } else {
        kpNotice.warning('middle', 2000, response.msg)
      }
    })
    .catch(error => {
      // console.log('获取全部省市区数据错误', error)
      params.errorback(error)
      kpNotice.warning('middle', 2000, error)
    })
}
function getCountryList(params) {
  grpc.call('/basic/country/list', params)
    .then(response => {
      // console.log('获取全部国家数据', response)
      if (response.code === 0) {
        params.callback(response)
      } else {
        kpNotice.warning('middle', 2000, response.msg)
      }
    })
    .catch(error => {
      // console.log('获取全部国家数据错误', error)
      params.errorback(error)
      kpNotice.warning('middle', 2000, error)
    })
}

function getIndustry(params) {
  grpc.call('/basic/industry/list', params)
    .then(response => {
      // console.log('获取行业数据', response)
      if (response.code === 0) {
        params.callback(response)
      } else {
        kpNotice.warning('middle', 2000, response.msg)
      }
    })
    .catch(error => {
      // console.log('获取行业数据错误', error)
      params.errorback(error)
      kpNotice.warning('middle', 2000, error)
    })
}
function getSignature(params) {
  grpc.call('/auth/agent/get/signature', params)
    .then(response => {
      if (response.code === 0) {
        params.callback(response)
      } else {
        kpNotice.warning('middle', 2000, response.msg)
      }
    })
    .catch(error => {
      kpNotice.warning('middle', 2000, error)
    })
}
function exchange(params) {
  let request = {
    cityName: params.cityName,
    countyName: params.countyName,
    provinceName: params.provinceName
  }
  grpc.call('/basic/exchange', request)
    .then(response => {
      if (response.code === 0) {
        params.callback(response)
      } else {
        kpNotice.warning('middle', 2000, response.msg)
      }
    })
    .catch(error => {
      kpNotice.warning('middle', 2000, error)
    })
}
function downLoadLink(params) {
  let request = {
    platform: 1
  }
  grpc.call('/basic/app_release/query/latest', request)
    .then(response => {
      params.callback(response)
    })
}

function getIndustry2(params) {
  return grpc.call('/basic/sys_industry/list', params)
}

function exchange2(params) {
  grpc.call('/basic/exchange', params)
        .then(response => {
          if (response.code === 0) {
            params.callback(response)
          } else {
            params.errorback && params.errorback(response.msg)
            kpNotice.warning('middle', 2000, response.msg)
          }
        })
        .catch(error => {
          params.errorback && params.errorback(error)
          kpNotice.warning('middle', 2000, error)
        })
}

export {
  getAllAddress,
  getCountryList,
  getIndustry,
  getSignature,
  exchange,
  downLoadLink,
  getIndustry2,
  exchange2
}



// WEBPACK FOOTER //
// ./src/controller/basic.js